'use client';

import { usePosthogCapture } from '@repo/sdk/analytics/posthog';
import { Button } from '@repo/ui/components';
import Image from 'next/image';
import { getUrl } from '@/app/@public/(auth)/(login)/_components/social-login/action.ts';
const SocialButton = ({
  source
}) => {
  const {
    posthogCapture
  } = usePosthogCapture();
  const capitalized = source.charAt(0).toUpperCase() + source.slice(1);
  const onClick = async () => {
    localStorage.setItem('newQuoteCallbackUrl', window.location.href);
    try {
      const res = await getUrl(source);
      if (res?.url) {
        window.location.href = res.url;
      }
    } catch (e) {
      localStorage.removeItem('newQuoteCallbackUrl');
      throw new Error(`${capitalized} login failed`);
    }
    posthogCapture(source + ' login');
  };
  return <Button className={'rounded-full'} onClick={onClick} type={'button'} variant={'outline'}>
      <Image alt={source} height={20} src={`/assets/${capitalized}.png`} width={20} />
      <div className={'mx-auto font-semibold text-[#4B4B4B] dark:text-slate-300'}>
        Continue with <span className={'capitalize'}>{source}</span>
      </div>
    </Button>;
};
export default SocialButton;